<template>
  <div class="content">
    <div class="col-md-8 ml-auto mr-auto">
      <h2 class="text-center">{{ $t('operators.title') }}</h2>
      <p class="text-center">
        {{ $t('operators.description') }}
      </p>
    </div>
    <div class="row mt-5">
      <operators-table/>
    </div>
  </div>
</template>
<script>
  import OperatorsTable from './OperatorsTable.vue'

  export default {
    name: 'operators',
    components: {
      OperatorsTable
    },
  };
</script>
